import * as React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
var SvgGillyHicksLogotypeSmall = function SvgGillyHicksLogotypeSmall(_ref) {
  var fill = _ref.fill,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? null : _ref$height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361 45",
    fill: fill,
    width: width,
    height: height,
    role: "img"
  }, /*#__PURE__*/React.createElement("title", null, "gilly hicks"), /*#__PURE__*/React.createElement("path", {
    d: "M20.688.797 21.1.8c7 0 12.5 2.4 16.3 7.2l.4.4-5.2 5.1-.4-.6c-2.5-3.2-6.4-5-10.8-5-8 0-13.6 6.1-13.6 14.8 0 8.7 5.5 14.7 13.4 14.7 6.6 0 10.7-3.6 11.6-10.1H19.6v-6.9h21l.1.8c.1.8.1 1.6.1 2.2 0 12.7-7.9 21.3-19.6 21.3-5.6 0-10.8-2-14.7-5.8C2.2 34.8 0 29.2 0 22.7 0 11.7 7.3.6 21.1.8ZM268 .4c6.7 0 12.1 2.3 16 7l.4.4-5.2 5.2-.4-.5c-2.5-3.1-6.1-4.8-10.5-4.8-8.2 0-13.7 6-13.7 14.8 0 8.7 5.5 14.8 13.4 14.8 4.5 0 8.1-1.8 11.1-5.6l.2-.6 5.3 4.8-.3.5c-3.7 5.3-9.6 8.2-16.7 8.2-12.1 0-20.9-9.3-20.9-22.1S255.7.4 268 .4Zm78.3.2c6.8 0 11.2 3 13.7 5.4l.5.4-5 5-.4-.4c-2.5-2.2-5.4-3.3-8.8-3.3-4.7 0-7.7 2.2-7.7 5.6 0 3.5 4 4.5 8.6 5.7.4.107.807.214 1.217.325l.495.134.497.138c5.482 1.539 11.279 3.883 11.191 11.803 0 7.9-6.1 13.2-15.3 13.2-6.1 0-11.2-2.1-15.6-6.4l-.5-.5 5.4-4.9.4.4c3.2 2.8 6.7 4.2 10.4 4.2 4.8 0 7.6-2.1 7.6-5.6 0-3.8-4-4.8-8.6-5.9-.63-.16-1.277-.323-1.932-.499l-.492-.134C336.633 23.788 331 21.373 331 13.4 331 5.9 337.3.6 346.3.6Zm-108.1.6V44h-8V1.2h8Zm-46.2 0v17.2h18.2V1.2h8V44h-8V25.9H192V44h-8V1.2h8Zm-135 0V44h-8V1.2h8Zm50.4 0v35.3h17.1V44H99.4V1.2h8Zm-30.6 0v35.3H94V44H68.8V1.2h8Zm223.3 0v17.2l16.7-17.2h10.1l-20 19.8 21.2 23h-10.5l-17.5-20v20h-8V1.2h8Zm-169.6.3 10.4 16.7 10.4-16.7h9.3l-15.9 24v18.2h-8V25.5l-16.2-24h10Z"
  }));
};
SvgGillyHicksLogotypeSmall.propTypes = propTypes;

export { SvgGillyHicksLogotypeSmall as default };
//# sourceMappingURL=GillyHicksLogotypeSmall.js.map
